import React from "react";
import { Row, Col, Typography, Space, Grid } from "antd";
import SupportImg from "../../assets/images/SupportImg.svg"; 

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function SupportSection() {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        background: "#ffffff",
        padding: screens.md ? "80px 64px" : "40px 24px",
      }}
    >
      <Row
        align="middle"
        gutter={[48, 48]}
        style={{
          maxWidth: 1400,
          margin: "0 auto",
        }}
      >
        {/* LEFT CONTENT */}
        <Col xs={24} md={12}>
          <Space direction="vertical" size={20}>
            <Title
              level={2}
              style={{
                color: "#2b1f5f",
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              24/7 support for your <br /> success
            </Title>

            <Text style={{ fontSize: 16, color: "#2b1f5f" }}>
              • Need help with your website? Get expert assistance via{" "}
              <strong>live chat or email</strong>.
            </Text>

            <Text style={{ fontSize: 16, color: "#2b1f5f" }}>
              • Say goodbye to long waits – we resolve issues in{" "}
              <strong>under 3 minutes</strong>.
            </Text>

            <Text style={{ fontSize: 16, color: "#2b1f5f" }}>
              • Eliminate communication barriers – our agents speak{" "}
              <strong>10+ languages</strong>.
            </Text>
          </Space>
        </Col>

        {/* RIGHT IMAGE */}
        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={SupportImg}
            alt="24/7 Support Chat"
            style={{
              width: "100%",
              maxWidth: 560,
              height: "auto",
            }}
          />
        </Col>
      </Row>
    </div>
  );
}
